import {useCallback, useState} from "react";
import {DriverActivityEntity} from "@ots-frontend/ots-data";
import {useLayer} from "react-laag";
import {UseLayerProps} from "react-laag/dist/useLayer";
import {GridCellContextMenu} from "../../data-grid/DataGrid/useDataGrid";
import {CellContextMenuEvent} from "@ag-grid-community/core"

export type UseDriverActivityContextMenuProps = {}

export type UseDriverActivityContextMenuResult = Pick<UseLayerProps, 'layerProps' | 'renderLayer'> & {
  isOpen: boolean
  contextMenu?: GridCellContextMenu<DriverActivityEntity>
  onCellContextMenu: (event: CellContextMenuEvent<DriverActivityEntity>) => void
}

export const useDriverActivityContextMenu = (props: UseDriverActivityContextMenuProps = {}): UseDriverActivityContextMenuResult => {

  const [contextMenu, setContextMenu] = useState<GridCellContextMenu<DriverActivityEntity>>();

  const _isOpen = typeof contextMenu !== "undefined";

  const {layerProps, renderLayer} = useLayer({
    isOpen: _isOpen,
    auto: true,
    placement: "bottom-end",
    triggerOffset: 16,
    containerOffset: 16,
    layerDimensions: layerSide => ({width: 200, height: contextMenu?.possibleHeight ?? 315}),
    onOutsideClick: () => setContextMenu(undefined),
    trigger: {
      getBounds: () => ({
        left: contextMenu?.bounds.x ?? 0,
        top: contextMenu?.bounds.y ?? 0,
        width: contextMenu?.bounds.width ?? 0,
        height: contextMenu?.bounds.height ?? 0,
        right: (contextMenu?.bounds.x ?? 0) + (contextMenu?.bounds.width ?? 0),
        bottom: (contextMenu?.bounds.y ?? 0) + (contextMenu?.bounds.height ?? 0)
      })
    }
  });

  const _onCellContextMenu = useCallback((event: CellContextMenuEvent<DriverActivityEntity>) => {
    const data = event.data
    if (data) {
      let possibleHeight: number | undefined = undefined
      if (data.tta || data.transport) {
        possibleHeight = 400
      } else {
        possibleHeight = 175
      }

      setContextMenu({
        col: 0,
        row: event.rowIndex ?? 0,
        bounds: (event.event?.target as HTMLElement)?.getBoundingClientRect(),
        data: data,
        possibleHeight: possibleHeight,
        onItemClick: () => setContextMenu(undefined)
      })
    } else {
      setContextMenu(undefined)
    }
  }, [])

  return {
    isOpen: _isOpen,
    layerProps: layerProps,
    renderLayer: renderLayer,
    contextMenu: contextMenu,
    onCellContextMenu: _onCellContextMenu
  };
}
